import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {LibraryEntry} from '../../models';

@Component({
    standalone: false,
    selector: 'app-item-description-tab',
    templateUrl: './item-description-tab.component.html'
})
export class ItemDescriptionTabComponent {
    @Input() entry: LibraryEntry;
    @Input() libraryType: string;
    @Input() formGroup: FormGroup;

    constructor() {
    }
}
